// extracted by mini-css-extract-plugin
export default {"navbar":"navbar-module--navbar--1JRn8","bodyContent":"navbar-module--body-content--RUWTd"};